import getUrlBase from "datastore/getUrlBase";
import paramsToQs from "util/paramsToQs";

/* Params is object, we'll write key, value pairs to the url */
export default async function post(url, params) {
  let fullUrl = `${getUrlBase()}${url}`;
  if (params && Object.keys(params).length > 0) {
    const urlParams = paramsToQs(params);
    fullUrl = `${getUrlBase()}${url}?${urlParams}`;
  }

  return fetch(fullUrl, {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  });
}
